import './UsersSelector.scss';
import { useLookupUsersQuery } from "../../stores/OkOkStore";
import type { User, RefUser } from "../../types/Users";
import { useTrads } from "../../contexts/trads/useTrads";



const UsersSelector = function({users,clickHandler,filtre}:{users:RefUser[],clickHandler?:React.Dispatch<React.SetStateAction<RefUser[]>>,filtre?:Record<string, string> }){
    const { data, error, isLoading } = useLookupUsersQuery(filtre??{});
    const {translate}=useTrads();
    const onAddUser = function(event:React.SyntheticEvent<HTMLLIElement>){
        event.preventDefault();
        const usr:number=(event.currentTarget.dataset.id)?parseInt(event.currentTarget.dataset.id):0;
        if(clickHandler){
            if(usr){
                clickHandler((users).concat([{id:usr}]));
            }
        }
    }

    const onRemoveUser = function(event:React.SyntheticEvent<HTMLLIElement>){
        event.preventDefault();
        const usr:number=(event.currentTarget.dataset.id)?parseInt(event.currentTarget.dataset.id):0;
        if(clickHandler){
            if(usr){
                clickHandler((users).filter(e=> e.id != usr));
            }
        }
    }



    return (
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <div className="userSelector row">
                    <div className="col-6">
                    <div className="card enabled">
                        <div className="card-header">
                            {translate('user_manager_active')}
                        </div>
                        <ul className="list-group  list-group-flush" >
                            {data.data.map((user:User)=>(
                                users.map(x=>x.id).includes(user.id)?
                                <li className="list-group-item" onClick={onRemoveUser} key={user.id} data-id={user.id}>{user.nom} {user.prenom} {user.identifiant}</li>
                                :null
                            ))}
                        </ul>
                    </div>
                    </div>
                    <div className="col-6">
                    <div  className="card dispo">
                        <div className="card-header">
                            {translate('user_manager_disponible')}
                        </div>
                        <ul  className="list-group  list-group-flush">
                            {data.data.map((user:User)=>(
                                !users.map(x=>x.id).includes(user.id)?
                                <li className="list-group-item" onClick={onAddUser} key={user.id} data-id={user.id}>{user.nom} {user.prenom} {user.identifiant}</li>
                                :null
                            ))}
                        </ul>
                    </div>
                    </div>            
                </div>
            ):null
    );
}
export default UsersSelector;